'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126 from "./presto.types$-Path$$anon$126.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Path$() {
  this.c7A = null;
  this.c7B = false;
  this.c7y = null;
  this.c7z = false;
  this.c7C = null;
  this.c7D = false;
}
export { $c_Lpresto_types$Path$ as $c_Lpresto_types$Path$ };
$p = $c_Lpresto_types$Path$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Path$;
/** @constructor */
function $h_Lpresto_types$Path$() {
}
export { $h_Lpresto_types$Path$ as $h_Lpresto_types$Path$ };
$h_Lpresto_types$Path$.prototype = $p;
$p.cHA = (function() {
  if ((!this.c7B)) {
    this.c7A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7B = true;
  }
  return this.c7A;
});
$p.iL = (function() {
  if ((!this.c7z)) {
    this.c7y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c7z = true;
  }
  return this.c7y;
});
$p.cIx = (function() {
  if ((!this.c7D)) {
    this.c7C = new $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126.$c_Lpresto_types$Path$$anon$126(this);
    this.c7D = true;
  }
  return this.c7C;
});
var $d_Lpresto_types$Path$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Path$, "presto.types$Path$", ({
  a14: 1,
  D: 1
}));
export { $d_Lpresto_types$Path$ as $d_Lpresto_types$Path$ };
var $n_Lpresto_types$Path$;
function $m_Lpresto_types$Path$() {
  if ((!$n_Lpresto_types$Path$)) {
    $n_Lpresto_types$Path$ = new $c_Lpresto_types$Path$();
  }
  return $n_Lpresto_types$Path$;
}
export { $m_Lpresto_types$Path$ as $m_Lpresto_types$Path$ };
//# sourceMappingURL=presto.types$-Path$.js.map
